<template lang="html">
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-actions>
            <v-row>
              <v-col
                cols="3"
                class="pb-0"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in name here"
                  append-icon="fas fa-search"
                  label="Search"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-spacer />

              <v-col
                cols="12"
                md="2"
                xl="2"
              >
                <setup-quality-managements-dialog-create @created="loadData" />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-data-table
            :items="qualityManagements"
            :loading="loading"
            :search="search"
            :headers="headers"
            show-expand
          >
            <template v-slot:item="props">
              <tr>
                <td :class="props.isExpanded? 'remove-bottom-border':'border-bottom' ">
                  <v-btn
                    icon
                    @click="props.expand(!props.isExpanded)"
                  >
                    <v-icon small> 
                      {{ props.isExpanded ? 'fa-chevron-up':'fa-chevron-down' }} 
                    </v-icon>
                  </v-btn>
                </td>

                <td :class="props.isExpanded? 'text-left remove-bottom-border':'text-left border-bottom'">
                  {{ props.item.name }}
                </td>

                <td :class="props.isExpanded? 'text-center remove-bottom-border':'text-center border-bottom'">
                  <setup-quality-managements-dialog-edit
                    :quality-management="props.item"
                    @updated="loadData"
                  />

                  <setup-quality-managements-dialog-delete
                    :quality-management="props.item"
                    @deleted="loadData"
                  />
                </td>
              </tr>
            </template>

            <template v-slot:expanded-item="{ item }">   
              <td
                :colspan="12"
                class="attempt-border-bottom"
              >
                <v-row>
                  <v-col cols="6">
                    <v-row>
                      <v-col
                        cols="12"
                        class="font-weight-bold"
                      >
                        Employee Listing
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="item.quality_management_employees.length>0"
                      no-gutters
                    >
                      <v-col
                        v-for="(employee,index) in item.quality_management_employees"
                        :key="index"
                        cols="4"
                      >
                        {{ index +1 }}. {{ employee.employee.person.name }}
                      </v-col>
                    </v-row> 
                    <v-row
                      v-else
                      no-gutters
                    >
                      <v-col cols="12">
                        No data
                      </v-col>
                    </v-row>
                  </v-col>
                  
                  <v-col cols="6">
                    <v-row>
                      <v-col
                        cols="12"
                        class="font-weight-bold"
                      >
                        Department Listing
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="item.quality_management_target_groups.length>0"
                      no-gutters
                    >
                      <v-col
                        v-for="(department,index) in item.quality_management_target_groups"
                        :key="index"
                        cols="4"
                      >
                        {{ index +1 }}. {{ (department.department||{}).name }}
                      </v-col>
                    </v-row>
                    <v-row
                      v-else
                      no-gutters
                    >
                      <v-col cols="12">
                        No data
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      SetupQualityManagementsDialogCreate: () => import('@/components/setup/quality-managements/DialogCreate'),
      SetupQualityManagementsDialogEdit: () => import('@/components/setup/quality-managements/DialogEdit'),
      SetupQualityManagementsDialogDelete: () => import('@/components/setup/quality-managements/DialogDelete'),
    },

    data () {
      return {
        qualityManagements: [],
        search: null,
        loading: false,
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
      }
    },

    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        this.loading = true

        this.$api.qualityManagement().list()
          .then(res => {
            this.qualityManagements = _.orderBy(res.data, ['name'], ['desc', 'asc'])

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.remove-bottom-border {
  border-bottom: 0px !important
}

.attempt-border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
</style>
